import { authGet } from "../../common/redux/ApiClient";

const baseUrl = process.env.REACT_APP_BASE_DOMAIN;;

export function fetchLotteryResultUI() {
  return authGet(
    `http://35.240.204.237/ok99memberApi/api/Member5/LotteryResultUI`,
    {}
  );
}
